import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

// The same cards as IDX Pages (a shared CategoryAccordion opening onto an embedded RefreshTable): a
// 72px header with a 24px chevron 16px before an 18px bold title, and a shaded header row above the
// table. Widgets has no count on the right.
export const styles = (theme: Theme) => {
	return ({
		// The layout leaves no space under page content, and this page has no sticky save bar to make
		// some. Figma leaves 40 under the last card (`3253:13620`), so the end of the list reads as the
		// end rather than a card cut off by the window.
		list: {
			paddingBottom: theme.spacing(5),
		},
		// The card itself is shared/category-accordion. Doubled `&&` so these outrank its own margin and
		// MUI's expanded-state rules: 16px between cards, and a header that doesn't grow when opened.
		accordion: {
			"&&, &&.Mui-expanded": {
				margin: theme.spacing(0, 0, 2),
			},
			"&&:last-child": {
				marginBottom: 0,
			},
		},
		summary: {
			"&&, &&.Mui-expanded": {
				minHeight: 72,
				padding: theme.spacing(0, 3),
			},
			"&& .MuiAccordionSummary-content": {
				margin: 0,
			},
		},
		header: {
			display: "flex",
			alignItems: "center",
			justifyContent: "space-between",
			gap: theme.spacing(2),
			width: "100%",
		},
		title: {
			display: "flex",
			alignItems: "center",
			gap: theme.spacing(2),
			fontSize: 18,
			fontWeight: 700,
			lineHeight: "24px",
			color: theme.palette.custom.textPrimary,
		},
		chevron: {
			flexShrink: 0,
			color: theme.palette.primary.main,
		},
		details: {
			padding: 0,
			borderTop: `1px solid ${theme.palette.custom.borderCard}`,
		},
		action: {
			minWidth: 0,
			whiteSpace: "nowrap",
		},
	} satisfies Record<string, CSSObject>);
};
